<div class="high-risk-panel">
    <div class="panel-grid">
        <div class="panel-col">
            <div class="panel-header">
                <h3>High Risk Hotels</h3>
            </div>
            <app-high-risk-hotels-table
                    [rows]="(highRiskHotels$ | async) ?? []"
                    [loading]="(loading$ | async) ?? false"
                    [daysInRange]="(daysInRange$ | async) ?? 0"
            ></app-high-risk-hotels-table>
        </div>

        <div class="divider"></div>

        <div class="panel-col">
            <div class="panel-header">
                <h3>High Risk Reports</h3>
            </div>
            <app-high-risk-reports-list></app-high-risk-reports-list>
        </div>
    </div>
</div>
